import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { initThirdPartyApis } from "./api/third-party.ts";
import "../../../index.css";

initThirdPartyApis();

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);

if (import.meta.env.DEV) {
  loadDevMessages();
  loadErrorMessages();
}
